import React from 'react';
import { InfoIcon } from 'lucide-react';
type PlaceholderNoteProps = {
  children: React.ReactNode;
  className?: string;
};

/** Dashed notice that flags copy needing review before publishing. */
export function PlaceholderNote({
  children,
  className = ''
}: PlaceholderNoteProps) {
  return <p className={`flex items-start gap-2 rounded-[10px] border border-dashed border-ink/20 px-3.5 py-2.5 text-[12.5px] leading-[1.5] text-ink-muted ${className}`} data-id="element-351" data-mp="2ylpf1ojeokgc">
      <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-352" data-mp="20zrzo00bov8m" />
      <span data-id="element-353" data-mp="25ws98kwdsg4h">{children}</span>
    </p>;
}